/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, Dispatch, SetStateAction } from "react";
import styles from "./SupervisorInitials.module.scss";
import SignatureCanvas from "react-signature-canvas-react17-compatible";
import { XLg } from "react-bootstrap-icons";
import { Row, Col, Button } from "react-bootstrap";
import { InitialDays } from "../../views/Timesheet/Timesheet";

export type SignatureProps = {
  day?: string;
  setInitialsDays: Dispatch<SetStateAction<InitialDays>>;
  removeEntry: Function;
  previousDay: string | null;
  editEntry: boolean;
  updatedDay: string | null;
};

const SupervisorInitials = ({
  day,
  setInitialsDays,
  removeEntry,
  editEntry,
  previousDay,
  updatedDay,
}: SignatureProps) => {
  const uniqueId = `supervisor-${day}`;
  const sigCanvasSupervisor = useRef<SignatureCanvas>({});
  let isSignatureProvided =
    Object.keys(sigCanvasSupervisor.current).length > 0 &&
    !sigCanvasSupervisor.current.isEmpty();

  const setInitials = () => {
    if (day && sigCanvasSupervisor?.current) {
      setInitialsDays((previousInitialDays) => ({
        ...previousInitialDays,
        [day as string]: sigCanvasSupervisor.current,
      }));
    }
  };

  const clearInitials = () => {
    if (day && sigCanvasSupervisor?.current) {
      sigCanvasSupervisor.current.clear();
      removeEntry(day);
    }
  };

  useEffect(() => {
    if (editEntry && updatedDay) {
      if (previousDay && updatedDay === day) {
        sigCanvasSupervisor.current.clear();
        removeEntry(previousDay);
      }
    }
  }, [editEntry, updatedDay]);

  return (
    <Row className={styles.Initials} data-testid="Signature">
      <Col lg={isSignatureProvided ? 9 : 12} xl={isSignatureProvided ? 9 : 12}>
        <SignatureCanvas
          id={uniqueId}
          name={uniqueId}
          key={uniqueId}
          canvasProps={{ className: styles.SupervisorInitials }}
          ref={sigCanvasSupervisor}
          clearOnResize={false}
          onEnd={setInitials}
        />
      </Col>
      {isSignatureProvided && (
        <Col lg={3} xl={3}>
          <div>
            <Button
              variant="danger"
              size={"sm"}
              onClick={() => {
                clearInitials();
              }}
            >
              <XLg size={17} />
            </Button>
          </div>
        </Col>
      )}
    </Row>
  );
};

export default SupervisorInitials;
